import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { Btn, H1, H4, H5 } from "../../../../AbstractElements";
import { KeyboardEventHandler, MouseEventHandler } from "react";
import { Close, SaveChanges } from "../../../../Constant";

interface CommonModalProp {
  children?: React.ReactNode;
  toggler?: KeyboardEventHandler<any> | MouseEventHandler<any>;
  size?: string;
  isOpen?: boolean;
  toggle?: () => void;
  title?: string;
  fade?: boolean;
  modalBodyClassName?: string;
  modalTitleClassName?: string;
  heading?: string;
  sizeTitle?: string;
  fullTitle?: string;
  staticTitle?: string;
  fullscreen?: true | "sm" | "md" | "lg" | "xl" | "xxl";
  centered?: boolean;
  onClosed?: () => void;
  backdrop?: boolean | "static";
}

const CommonModal = ({ fade, backdrop, centered, fullscreen, size, isOpen, toggle, title, onClosed, sizeTitle, fullTitle, modalBodyClassName, children }: CommonModalProp) => {
  return (
    <Modal fade={fade} backdrop={backdrop} centered={centered} fullScreen={fullscreen} size={size} isOpen={isOpen} toggle={toggle} onClosed={onClosed}>
      {(title || sizeTitle || fullTitle) && (
        <div className="modal-header" onClick={toggle}>
          {title && <H5>{title}</H5>}
          {sizeTitle && <H4>{sizeTitle}</H4>}
          {fullTitle && <H1 className="fs-5">{fullTitle}</H1>}
          <Btn color="light" className="btn-close" type="button"></Btn>
        </div>
      )}
      <ModalBody className={modalBodyClassName ? modalBodyClassName : ""}>{children}</ModalBody>
      {(title || fullTitle) && (
        <ModalFooter>
          <Btn color="secondary" type="button" onClick={toggle}>{Close}</Btn>
          <Btn color="primary" type="button">{SaveChanges}</Btn>
        </ModalFooter>
      )}
    </Modal>
  );
};

export default CommonModal;
